var $3672d5aff8c10fba$exports = {};
$3672d5aff8c10fba$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$3672d5aff8c10fba$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
